<!--
 *                                                     __----~~~~~~~~~~~------___
 *                                    .  .   ~~//====......          __--~ ~~
 *                    -.            \_|//     |||\\  ~~~~~~::::... /~
 *                 ___-==_       _-~o~  \/    |||  \\            _/~~-
 *         __---~~~.==~||\=_    -_--~/_-~|-   |\\   \\        _/~
 *     _-~~     .=~    |  \\-_    '-~7  /-   /  ||    \      /
 *   .~       .~       |   \\ -_    /  /-   /   ||      \   /
 *  /  ____  /         |     \\ ~-_/  /|- _/   .||       \ /
 *  |~~    ~~|--~~~~--_ \     ~==-/   | \~--===~~        .\
 *           '         ~-|      /|    |-~\~~       __--~~
 *                       |-~~-_/ |    |   ~\_   _-~            /\
 *                            /  \     \__   \/~                \__
 *                        _--~ _/ | .-~~____--~-/                  ~~==.
 *                       ((->/~   '.|||' -_|    ~~-/ ,              . _||
 *                                  -_     ~\      ~~---l__i__i__i--~~_/
 *                                  _-~-__   ~)  \--______________--~~
 *                                //.-~~~-~_--~- |-------~~~~~~~~
 *                                       //.-~~~--\
 *                       ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * 
 *                               神兽保佑            永无BUG
 * 
 * @Author: 路守恒
 * @LastEditors: 路守恒
 * @Date: 2021-12-27 13:45:28
 * @LastEditTime: 2022-03-18 16:23:01
 * @FilePath: \news2021\src\components\index.vue
 * @Description: 
 -->

<!--
 *  ┌───┐   ┌───┬───┬───┬───┐ ┌───┬───┬───┬───┐ ┌───┬───┬───┬───┐ ┌───┬───┬───┐
 *  │Esc│   │ F1│ F2│ F3│ F4│ │ F5│ F6│ F7│ F8│ │ F9│F10│F11│F12│ │P/S│S L│P/B│  ┌┐    ┌┐    ┌┐
 *  └───┘   └───┴───┴───┴───┘ └───┴───┴───┴───┘ └───┴───┴───┴───┘ └───┴───┴───┘  └┘    └┘    └┘
 *  ┌───┬───┬───┬───┬───┬───┬───┬───┬───┬───┬───┬───┬───┬───────┐ ┌───┬───┬───┐ ┌───┬───┬───┬───┐
 *  │~ `│! 1│@ 2│# 3│$ 4│% 5│^ 6│& 7│* 8│( 9│) 0│_ -│+ =│ BacSp │ │Ins│Hom│PUp│ │N L│ / │ * │ - │
 *  ├───┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─────┤ ├───┼───┼───┤ ├───┼───┼───┼───┤
 *  │ Tab │ Q │ W │ E │ R │ T │ Y │ U │ I │ O │ P │{ [│} ]│ | \ │ │Del│End│PDn│ │ 7 │ 8 │ 9 │   │
 *  ├─────┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴─────┤ └───┴───┴───┘ ├───┼───┼───┤ + │
 *  │ Caps │ A │ S │ D │ F │ G │ H │ J │ K │ L │: ;│" '│ Enter  │               │ 4 │ 5 │ 6 │   │
 *  ├──────┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴────────┤     ┌───┐     ├───┼───┼───┼───┤
 *  │ Shift  │ Z │ X │ C │ V │ B │ N │ M │< ,│> .│? /│  Shift   │     │ ↑ │     │ 1 │ 2 │ 3 │   │
 *  ├─────┬──┴─┬─┴──┬┴───┴───┴───┴───┴───┴──┬┴───┼───┴┬────┬────┤ ┌───┼───┼───┐ ├───┴───┼───┤ E││
 *  │ Ctrl│    │Alt │         Space         │ Alt│    │    │Ctrl│ │ ← │ ↓ │ → │ │   0   │ . │←─┘│
 *  └─────┴────┴────┴───────────────────────┴────┴────┴────┴────┘ └───┴───┴───┘ └───────┴───┴───┘
 * 
 * @Author: 路守恒
 * @LastEditors: 路守恒
 * @Date: 2021-12-27 13:45:28
 * @LastEditTime: 2021-12-27 14:41:09
 * @FilePath: \news2021\src\components\index.vue
 * @Description: 
 -->

<template>
  <div class="wrap">
    <video
      :src="item.video"
      class="wrap-bg"
      loop="loop"
      autoplay
      muted
      v-for="(item, index) in tabList"
      :key="index"
      v-show="index === tabListIndex"
    ></video>
    <div class="wrap-content">
      <img src="../assets/img/index-left-bg.png" class="wrap-content-left" />
      <div class="wrap-tab-content">
        <ul>
          <li
            v-for="(item, index) in tabList"
            :key="index"
            :style="{ backgroundColor: item.bgColor }"
            :class="{ isActive: item.active }"
          >
            <i :class="{ isActive: item.active }"></i>
            <p @mouseenter="liEnter(item)" @click="toDesc(item)">
              {{ item.title }}
            </p>
          </li>
        </ul>
        <p class="wrap-tab-content-intro">
          {{ tabList[tabListIndex].intro }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabListIndex: 0,
      tabList: [
        {
          index: 0,
          title: 'Spring Festival',
          intro:
            'The Chinese New Year,is also the most important festival of the year.',
          active: true,
          bgColor: '#863238',
          video: 'https://static.hntv.tv/total/jrxl/index/chunjie.mp4'
        },
        {
          index: 1,
          title: 'Lantern Festival',
          intro:
            'The first full moon night of the year,is a festival to enjoy the moon and watch lanterns.',
          active: false,
          bgColor: '#9e363e',
          video: 'https://static.hntv.tv/total/jrxl/index/yuanxiao.mp4'
        },
        {
          index: 2,
          title: 'Ching Ming Festival',
          intro:
            'A festival for traveling and worshipping ancestors in spring.',
          active: false,
          bgColor: '#a73e3f',
          video: 'https://static.hntv.tv/total/jrxl/index/qingming.mp4'
        },
        {
          index: 3,
          title: 'Dragon Boat Festival',
          intro: 'A festival to pray for health and unity of nation.',
          active: false,
          bgColor: '#c33f40',
          video: 'https://static.hntv.tv/total/jrxl/index/duanwu.mp4'
        },
        {
          index: 4,
          title: `July Seventh Day`,
          intro: `Chinese Valentine's day, girls' day.`,
          active: false,
          bgColor: '#be5b40',
          video: 'https://static.hntv.tv/total/jrxl/index/qixi.mp4'
        },
        {
          index: 5,
          title: 'Mid-Autumn Festival',
          intro: 'A festival to celebrate harvest and family reunion.',
          active: false,
          bgColor: '#c68038',
          video: 'https://static.hntv.tv/total/jrxl/index/zhongqiu.mp4'
        },
        {
          index: 6,
          title: 'Chung Yeung Festival',
          intro:
            'A festival of climbing high to pray for blessings, Thanksgiving and respect for the elderly.',
          active: false,
          bgColor: '#f2ca97',
          video: 'https://static.hntv.tv/total/jrxl/index/chongyang.mp4'
        }
      ]
    }
  },
  methods: {
    liEnter(item) {
      this.tabList.forEach((item) => {
        item.active = false
      })
      this.tabList[item.index].active = true
      this.tabListIndex = item.index
    },
    toDesc(item) {
      let tabListTitle = item.title.replace(/\s+/g, '')
      this.$router.push({ name: 'desc', params: { tabListTitle } })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.wrap {
  width: 100vw;
  height: 100vh;
  position: relative;
  &-bg {
    width: 100vw;
    height: 100vh;
    object-fit: fill;
  }
  &-content {
    position: absolute;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: space-between;
    align-items: center;
    &-left {
      margin-left: 40px;
    }
  }
  &-tab {
    &-content {
      color: #fff;
      height: 600px;
      > ul {
        list-style: none;
        padding-inline-start: 0;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        li {
          position: relative;
          font-size: 21px;
          letter-spacing: 2px;
          text-indent: 10px;
          font-family: 'Bebas';
          -webkit-font-smoothing: subpixel-antialiased;
          -moz-osx-font-smoothing: grayscale;
          display: flex;
          align-items: center;
          text-align: left;
          width: 49px;
          height: 574px;
          writing-mode: vertical-lr; /*从左向右 从右向左是 writing-mode: vertical-rl;*/
          writing-mode: tb-lr; /*IE浏览器的从左向右 从右向左是 writing-mode: tb-rl；*/
          p {
            cursor: pointer;
            height: 100%;
          }
          &.isActive {
            background-color: #fff !important;
            color: #242424 !important;
          }
          i {
            position: relative;
            top: -30px;
            width: 15px;
            height: 15px;
            border-radius: 50%;
            &.isActive {
              background-color: #fff;
            }
          }
        }
      }
      &-intro {
        width: 325px;
        font-size: 18px;
        word-break: keep-all;
        text-align: justify;
        text-align-last: left;
        text-justify: inter-cluster;
        -webkit-font-smoothing: subpixel-antialiased;
        -moz-osx-font-smoothing: grayscale;
      }
    }
  }
}
</style>
